module.exports = __webpack_public_path__ + "img/puppis.23719c1b.png";